import dynamic from 'next/dynamic';
import type { ImageProps } from 'next/image';

import { DynamicIcon } from '@natu/ui/DynamicIcon';

const ResponsiveImage = dynamic(() =>
  import('@natu/ui/ResponsiveImage').then(mod => mod.ResponsiveImage),
);

interface CardContentProps {
  image?: ImageProps;
  title?: string;
  content?: string;
  buttonLabel: string;
}

export const CardContent = ({ image, title, content, buttonLabel }: CardContentProps) => {
  return (
    <>
      {image?.src && <ResponsiveImage {...image} className="mb-4" />}
      <hr className="group-hover:bg-primary-600 group-focus-visible:bg-primary-600 h-0.5 min-h-0.5 border-0 bg-gray-100 transition-colors duration-300" />
      <div className="flex h-full flex-col justify-between gap-y-5 px-4 pt-6">
        <div>
          {title && (
            <h3 className="mb-1 text-center text-lg font-semibold -tracking-[0.2px] text-gray-900 lg:mb-2 xl:text-xl">
              {title}
            </h3>
          )}
          {content && <p className="text-center -tracking-[0.2px] text-gray-600">{content}</p>}
        </div>
        <div className="text-primary-600 group-hover:decoration-primary-600 group-focus-visible:decoration-primary-600 inline-flex items-center justify-center py-3 font-semibold uppercase leading-[24px] tracking-[-0.2px] underline decoration-transparent underline-offset-2 transition-colors">
          {buttonLabel}
          <DynamicIcon icon="arrowRight" className="ml-2" />
        </div>
      </div>
    </>
  );
};
